export default "/_next/static/images/img1-a8537e8cfd002569f626f6531e759052.png";